import { render, staticRenderFns } from "./CoachScoutingSummary.vue?vue&type=template&id=1163250d&scoped=true&"
import script from "./CoachScoutingSummary.vue?vue&type=script&lang=ts&"
export * from "./CoachScoutingSummary.vue?vue&type=script&lang=ts&"
import style0 from "./CoachScoutingSummary.vue?vue&type=style&index=0&id=1163250d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1163250d",
  null
  
)

export default component.exports